// @flow
import React from "react";
import { useSelector } from "react-redux";

function PhotoRatioOptions() {
  const config = useSelector(state => state.configReducer.config);

  let photoRatioOptions;

  switch (config.setting) {
    case "1":
      photoRatioOptions = (
        <React.Fragment>
          <option value="1">Landscape</option>
          <option value="0">Portrait</option>
          <option value="2">Polaroid</option>
          <option value="3">Extended overlay</option>
        </React.Fragment>
      );
      break;
    case "2":
      photoRatioOptions = (
        <React.Fragment>
          <option value="1">Landscape</option>
          <option value="2">Polaroid</option>
        </React.Fragment>
      );
      break;
    case "3":
      photoRatioOptions = (
        <React.Fragment>
          <option value="1">Landscape</option>
          <option value="2">Polaroid</option>
        </React.Fragment>
      );
      break;
    case "7":
    case "6":
    case "4":
      photoRatioOptions = (
        <React.Fragment>
          <option value="1">Landscape</option>
        </React.Fragment>
      );
      break;
    case "5":
    case "8":
      photoRatioOptions = (
        <React.Fragment>
          <option value="1">Landscape</option>
          <option value="0">Portrait</option>
          <option value="2">Polaroid</option>
        </React.Fragment>
      );
      break;
    default:
      photoRatioOptions = null;
      break;
  }

  return photoRatioOptions;
}
export default PhotoRatioOptions;



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/config-form-subsections/PhotoRatioOptions.jsx